import '../../common/sentry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import windowWrapper from '../literably-ui/utils/window-wrapper';
import App, { Props } from './app';

const props = windowWrapper.get<Props>('scorer_signup_props');

const root = createRoot(document.getElementById('scorer_signup')!);

root.render(
  <StrictMode>
    <App {...props} />
  </StrictMode>,
);
